import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/store";

export default function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (user === null) {
    return <div className="flex h-[60vh] items-center justify-center text-gray-400" data-testid="auth-loading">Loading…</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
